import React, { useEffect, useState } from 'react';
import axios from 'axios';
import '../../App.css';
import './services.css';
import { Link } from 'react-router-dom'; 
import Sidebar from '../../Sidebar';
import Seo from "../../Seo";


function Web_app(){
    const [items, setItems] = useState([]);

    useEffect(() => {
      axios.get('/backend/home.php', {
        headers: {
            'Custom-type': 'service2',
            'Content-Type': 'application/json',  // Beispiel für Content-Type
            // Weitere Header können hier hinzugefügt werden
        }
    })
    .then(response => {
        setItems(response.data);
    })
    .catch(error => {
        console.error('Es gab einen Fehler beim Abrufen der Daten:', error);
    });
    
    }
    , []);// Leer, d.h. dieser Effekt wird nur einmal nach dem initialen Rendern ausgeführt

    useEffect(() => {
        LanguageChange();
      }, [items]);// Dieser Effekt wird nur ausgeführt, wenn sich `items` ändert
    
      const LanguageChange = () => {
        if (items.length > 0) {
          const languageIndex = sessionStorage.getItem("language_index");
          const isEnglish = languageIndex != null && languageIndex == 1;
      
          const texts = ["text1", "e_text1", "e_text2"];
          const topics = ["", "e_topic1", "e_topic2"];
            document.getElementById('link').innerText= isEnglish ? " Please contact me" : " Kontaktieren Sie mich";
          document.getElementById('topic_header').innerText= isEnglish ? "Web development & company websites" : "Webentwicklung & Firmen-Webseiten";
          document.getElementById('text_header').innerText=isEnglish ? "I offer customized web development that achieves your goals.":"Ich biete maßgeschneiderter Webentwicklung, die Ihre Ziele erreicht ";

           document.getElementById('under_topic01').innerText= isEnglish ? "· Individually designed:" : "· Individuell gestaltet:";
           document.getElementById('under_topic02').innerText= isEnglish ? "· User-friendly:" : "· Benutzerfreundlich:";
           document.getElementById('under_topic03').innerText= isEnglish ? "· Optimised for all devices:" : "· Optimiert für alle Geräte:";
           document.getElementById('under_topic04').innerText= isEnglish ? "· Individual functions:" : "· Individuelle Funktionen:";
           document.getElementById('under_topic05').innerText= isEnglish ? "· Safe and reliable:" : "· Sicher & zuverlässig:";
           document.getElementById('under_topic06').innerText= isEnglish ? "· Expandable:" : "· Erweiterbar:";
           document.getElementById('under_topic07').innerText= isEnglish ? "Technical advantages" : "Technische Vorteile";
           document.getElementById('under_topic08').innerText= isEnglish ? "· SEO-optimised:" : "· SEO-optimiert:";
           document.getElementById('under_topic09').innerText= isEnglish ? "· Fast loading times:" : "· Schnelle Ladezeiten:";
           document.getElementById('under_topic10').innerText= isEnglish ? "· Easy to maintain:" : "· Pflegeleicht:";
           document.getElementById('under_txt01').innerText= isEnglish ? " A design that suits your company." : " Ein Design, das zu Ihrem Unternehmen passt.";
           document.getElementById('under_txt02').innerText= isEnglish ? " Clear structure and easy navigation." : " Klare Struktur und einfache Navigation.";
           document.getElementById('under_txt03').innerText= isEnglish ? " Your site looks perfect on PCs, tablets and smartphones." : " Ihre Seite sieht auf PC, Tablet und Smartphone perfekt aus.";
           document.getElementById('under_txt04').innerText= isEnglish ? " e.g. customer portals, appointment bookings, internal tools." : " z. B. Kundenportale, Terminbuchungen, interne Tools.";
           document.getElementById('under_txt05').innerText= isEnglish ? " Data storage in certified cloud environments upon request." : " Datenhaltung auf Wunsch in zertifizierten Cloud-Umgebungen.";
           document.getElementById('under_txt06').innerText= isEnglish ? " The application grows with your business." : " Die Anwendung wächst mit Ihrem Unternehmen.";
           document.getElementById('under_txt07').innerText= isEnglish ? " So that your customers can find you more easily online." : " Damit Ihre Kunden Sie online besser finden.";
           document.getElementById('under_txt08').innerText= isEnglish ? " Optimised for performance and user experience." : " Optimiert für Performance und Nutzererlebnis.";
           document.getElementById('under_txt09').innerText= isEnglish ? " You can easily update the content yourself." : " Inhalte können Sie selbst einfach aktualisieren.";
          
          texts.forEach((id, index) => {
            const element = document.getElementById(id);
            const topic_element = document.getElementById(topics[index]);
            if (element && items[index]) {
              element.innerHTML = isEnglish ? items[index].en_text : items[index].de_text;
            }
            if(topic_element){
                topic_element.innerHTML = isEnglish ? items[index].en_topic : items[index].de_topic;
            }
          });
        } else {
        //  document.getElementById('text1').innerHTML = "Loading...";
        }
      };
    
    return(
      <>
                    <Seo
  title="Webentwicklung – Moderne Websites & Web-Apps | Finn Mikoschek"
  description="Individuelle Webentwicklung für Unternehmen: Moderne Websites und Web-Anwendungen, performant, responsiv und suchmaschinenoptimiert."
/>
        <div>
            <Sidebar onLanguageChange={LanguageChange}/>
            <div class="App-header">
            <div class="img_header"><h1 id='topic_header'></h1><p id='text_header'></p><img src="/images/web_app_header.webp"></img></div>
            <div class="text_container" id="service-container">
            <div class="text_container_data">
      <a id="text1"> <Link to="/contact" id="link" >Kontaktieren Sie mich</Link></a>

      
            <div class='enumeration'>
        <div class='enumeration_element' >
          <img src="/images/services_b2.webp"></img>
          <div class='enumeration_text'> 
            <h4 id="e_topic1"></h4>
        <a id="e_text1"></a>
        <div className='enumerationColumn'>
            <div className='enumerationRow'><h4 id="under_topic01"></h4><a id="under_txt01"></a></div>
         <div className='enumerationRow'><h4 id="under_topic02"></h4><a id="under_txt02"></a></div>
          <div className='enumerationRow'><h4 id="under_topic03"></h4><a id="under_txt03"></a></div>
        </div>

        
      
        </div>
        </div>
                        <div class='enumeration_element' >
          <img src="/images/services_b3.webp"></img>
          <div class='enumeration_text'> <h4 id="e_topic2"></h4>
        <a id="e_text2"></a>
        <div className='enumerationColumn'>
            <div className='enumerationRow'><h4 id="under_topic04"></h4><a id="under_txt04"></a></div>
         <div className='enumerationRow'><h4 id="under_topic05"></h4><a id="under_txt05"></a></div>
          <div className='enumerationRow'><h4 id="under_topic06"></h4><a id="under_txt06"></a></div>
        </div>

        
      
        </div>
        </div>
                <div class='enumeration_element' >
          <img src="/images/seo.webp"></img>
          <div class='enumeration_text'> <h4 id="under_topic07"></h4>
        
        <div className='enumerationColumn'>
            <div className='enumerationRow'><h4 id="under_topic08"></h4><a id="under_txt07"></a></div>
         <div className='enumerationRow'><h4 id="under_topic09"></h4><a id="under_txt08"></a></div>
          <div className='enumerationRow'><h4 id="under_topic10"></h4><a id="under_txt09"></a></div>
        </div>

        
      
        </div>
        </div>



      </div>
            </div>
            </div>
            </div>
        </div>
</>
    );

}

export default Web_app;